var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-results__body"},[_c(_vm.currentType,{tag:"component",attrs:{"results":_vm.results.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }